import { Pipe, PipeTransform } from '@angular/core';
import { formatCamelCaseAsTitleCase } from '../utils/formatters.utils';

@Pipe({
  name: 'camelCaseToTitleCase',
})
export class CamelCaseToTitleCasePipe implements PipeTransform {
  transform(value: string | null): string | null {
    return value ? formatCamelCaseAsTitleCase(value) : null;
  }
}
